import React, { useEffect, useState, useRef } from "react";
import Menu from '../../components/sturtural/Menu';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { TabPanel, TabView } from "primereact/tabview";
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import JSZip from "jszip";
import { storage } from "../../helpers/storage";

const validationsForm = (ct) => {
    let errors = {};

    if (!ct.trim()) {
        errors.ct = "El campo (ct) es requerido.";
    } else if (!(/(\d{2})([a-zA-Z]{3})(\d{4})([a-zA-Z]{1})/g).test(ct.trim())) {
        errors.ct = "El campo (ct) es inválido."
    }
    return errors;
}

const ImprentaVales = () => {

    const options = [
        { label: 'Vales', value: 10 },
        { label: 'Nómina', value: 17 }
    ]

    const estatus = [
        { label: 'Todos', value: 0 },
        { label: 'Pendientes', value: 1 },
        { label: 'Entregado parcial', value: 6 },
        { label: 'Entregado completo', value: 2 },
    ]


    const [ct, setCT] = useState('');
    const [cts, setCTs] = useState('');
    const [option, setOption] = useState(options[0].value);
    const [status, setStatus] = useState(estatus[0].value);
    const [municipios, setMunicipios] = useState([]);
    const [municipio, setMunicipio] = useState(null);
    const [localidades, setLocalidades] = useState([]);
    const [escuelas, setEscuelas] = useState([]);
    const [supervisiones, setSupervisiones] = useState([]);
    const [lstEscuelas, setLstEscuelas] = useState([]);
    const [lstSupervisiones, setLstSupervisiones] = useState([]);
    const [localidad, setLocalidad] = useState(null)
    const [loading, setLoading] = useState(false);
    const [lstPDF, setLstPDF] = useState([])
    const [activeIndex, setActiveIndex] = useState(0);
    const [getGrupos, setGetGrupos] = useState(null)
    const [selectedGrupos, setSelectedGrupo] = useState(null)

    const [errors, setErrors] = useState(true);

    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');
    const toast = useRef(null);

    var zip = new JSZip();

    const navigate = useNavigate();

    useEffect(() => {
        if (![1, 3, 17, 19, 20].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        if (activeIndex === 0) {
            helpHttp().post(`${BASE_API}Escuela/CargarMunicipios`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.length > 0) {
                    setMunicipios(res)
                    setMunicipio(res[0])
                    getLocalidades(res[0].IdMunicipio)
                }
            })
        }
    }, [activeIndex]);

    useEffect(() => {
        if (municipio !== null && localidad !== null) {
            getEscuelas(lstSupervisiones)
        }
    }, [municipio, localidad]);

    const comprimirPDF = (files) => {
        files.forEach((x, index) => {
            zip.file(x.name, x, { base64: true })
            if (files.length === index + 1) {
                zip.generateAsync({ type: "base64" }).then(function (content) {
                    const linkSource = `data:application/zip;base64,${content}`;
                    const downloadLink = document.createElement('a');
                    const titulo1 = options.find(x => x.value === option)
                    const date = new Date()
                    const fileName = `${municipio.Municipio}_${titulo1.label}_${date.toLocaleDateString('es-MX')}.zip`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLstPDF([])
                    setLoading(false)
                })
            }
        })
    }

    const comprimirPDFConsulta = (files) => {
        files.forEach((x, index) => {
            zip.file(x.name, x, { base64: true })

            if (files.length === index + 1) {
                zip.generateAsync({ type: "base64" }).then(function (content) {
                    const linkSource = `data:application/zip;base64,${content}`;
                    const downloadLink = document.createElement('a');
                    const titulo1 = options.find(x => x.value === option)
                    const date = new Date()
                    const fileName = `${titulo1.label}_${date.toLocaleDateString('es-MX')}.zip`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLstPDF([])
                    setLoading(false)
                })
            }
        })
    }

    const comprimirPDFGrupos = (codigo, files) => {
        files.forEach((x, index) => {
            zip.file(x.name, x, { base64: true })

            if (files.length === index + 1) {
                setLoading(false)
                zip.generateAsync({ type: "base64" }).then(function (content) {
                    const linkSource = `data:application/zip;base64,${content}`;
                    const downloadLink = document.createElement('a');
                    const titulo1 = options.find(x => x.value === option)
                    const date = new Date()
                    const fileName = `${codigo}_${titulo1.label}_${date.toLocaleDateString('es-MX')}.zip`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLoading(false)
                })
            }
        })
    }

    const downloadPDF = (base64) => {
        const linkSource = `data:application/pdf;base64,${base64}`;
        const downloadLink = document.createElement('a');
        const titulo1 = options.find(x => x.value === option)
        const date = new Date()
        const fileName = `${titulo1.label}_${ct}_Ciclo_${ciclo.Descripcion}_${date.toLocaleDateString('es-MX')}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const downloadPDFMulti = (dataurl, filename) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const obtenerValesNomina = async (e) => {
        e.preventDefault();
        setErrors(validationsForm(ct))

        if (Object.keys(errors).length === 0) {
            setLoading(true)
            if (option !== 17) {
                const arrConsulta = {
                    reporte: option,
                    idUsuario: storage.get('id'),
                    Folio: null,
                    parametrosExtra: option === 17 ? `[{ "opcion": ${status}, "IdCicloEscolar": ${ciclo.IdCicloEscolar} }]` : `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`,
                    CicloEscolar: ciclo.Descripcion.split('(')[0].trim(),
                    IdEscuela: ct,
                    IdTurno: null,
                    IdNivel: null,
                    Grado: "",
                    Grupo: "",
                    CURP: ""
                }

                helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                    body: arrConsulta,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    console.log(res)
                    if (res.SUCCESS) {
                        if (option !== 17) {
                            if (res.ITEMS.IdEstatus !== 10 && res.ITEMS.IdEstatus !== 3) {
                                downloadPDF(res.ITEMS.Vales);
                            } else {
                                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.messagge, life: 5000 })
                            }
                        }
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No se encuentra registrado.", life: 5000 })
                    }
                    setLoading(false);
                })
            } else {
                if (selectedGrupos !== null) {
                    if (selectedGrupos.length > 0) {
                        obtenerNominaXGrupo()
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No ha seleccionado grupos.", life: 5000 })
                        setLoading(false)
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No ha seleccionado grupos.", life: 5000 })
                    setLoading(false)
                }
            }
        }
    }

    const obtenerNominaXGrupo = async () => {
        const files = await Promise.all(selectedGrupos.map(async (x, index) => {
            const arrConsulta = {
                reporte: option,
                idUsuario: storage.get('id'),
                Folio: null,
                parametrosExtra: `[{ "opcion": ${status}, "IdCicloEscolar": ${ciclo.IdCicloEscolar} }]`,
                CicloEscolar: ciclo.Descripcion.split('(')[0].trim(),
                IdEscuela: ct,
                IdTurno: x.IdTurno,
                IdNivel: x.IdNivel,
                Grado: x.Grado,
                Grupo: x.Grupo,
                CURP: ""
            }
            return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                body: arrConsulta,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${x.Grado}-${x.Grupo}_Ciclo_${ciclo.Descripcion}.pdf`))
        }));

        if (files.length !== 0) {
            comprimirPDFGrupos(ct, files)
        } else {
            setLoading(false)
        }
    }

    const obtenerValesNominaMulti = async () => {
        console.log('option', option)
        setLoading(true)
        const files = await Promise.all(
            lstEscuelas.map(async (escuela) => {
                const arrConsulta = {
                    reporte: 10,
                    idUsuario: storage.get('id'),
                    Folio: null,
                    parametrosExtra: option === 17 ? `[{ "opcion": ${status}, "IdCicloEscolar": ${ciclo.IdCicloEscolar} }]` : `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`,
                    IdEscuela: escuela.toString(),
                    CicloEscolar: ciclo.Descripcion.split('(')[0].trim(),
                    IdTurno: null,
                    IdNivel: null,
                    Grado: 0,
                    Grupo: "",
                    CURP: ""
                }
                return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                    body: arrConsulta,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.SUCCESS) {
                        if (option !== 17) {
                            if (res.ITEMS.IdEstatus !== 10 && res.ITEMS.IdEstatus !== 3) {
                                return downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS.Vales}`, `${escuela}_Ciclo_${ciclo.Descripcion}.pdf`);
                            } else {
                                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.messagge, life: 5000 })
                                return false;
                            }
                        } else {
                            return downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${escuela}_Ciclo_${ciclo.Descripcion}.pdf`);
                        }
                    }
                })
            })
        )
        const remove = files.filter(x => x !== false)
        if (remove.length !== 0) {
            comprimirPDF(remove)
        } else {
            setLoading(false);
        }
    }

    const obtenerValesNominaConsulta = async (e) => {
        e.preventDefault();
        const arrCTs = cts.split(' ');

        setLoading(true);
        const files = await Promise.all(arrCTs.filter(n => n).map(async (x, index) => {
            const arrConsulta = {
                reporte: option === 17 ? 13 : option,
                idUsuario: storage.get('id'),
                Folio: null,
                parametrosExtra: option === 17 ? `[{ "opcion": ${status}, "IdCicloEscolar": ${ciclo.IdCicloEscolar} }]` : `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`,
                IdEscuela: x,
                IdTurno: null,
                IdNivel: null,
                CicloEscolar: ciclo.Descripcion.split('(')[0].trim(),
                Grado: 0,
                Grupo: "",
                CURP: ""
            }
            return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                body: arrConsulta,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    if (option !== 17) {
                        if (res.ITEMS.IdEstatus !== 10 && res.ITEMS.IdEstatus !== 3) {
                            return downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS.Vales}`, `${x}_Ciclo_${ciclo.Descripcion}.pdf`);
                        } else {
                            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.messagge, life: 5000 })
                            return false;
                        }
                    } else {
                        return downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${x}_Ciclo_${ciclo.Descripcion}.pdf`);
                    }
                }
            })
        }));

        const remove = files.filter(x => x !== false);
        if (remove.length !== 0) {
            comprimirPDFConsulta(remove)
        } else {
            setLoading(false)
        }
    }

    const getLocalidades = (municipio) => {
        helpHttp().post(`${BASE_API}Escuela/CargarLocalidades/${municipio}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.length > 0) {
                /* [1].includes(parseInt(perfil)) && res.unshift({
                    IdLocalidad: 0,
                    Localidad: 'Todos'
                }) */
                setLocalidades(res)
                setLocalidad(res[0].IdLocalidad);
                getSupervisiones(municipio, res[0].IdLocalidad)
                setLstEscuelas([]);
            }
        })
    }

    const getSupervisiones = (municipio, localidad) => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                "sp": "SpdListarSupervisiones",
                "Tipo": 0,
                "parametros": [
                    { "IdMunicipio": municipio },
                    { "IdLocalidad": localidad },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setSupervisiones(res.ITEMS);
                setLstSupervisiones([])
                setLstEscuelas([])
            }
        })
    }
    const getEscuelas = (sup) => {
        if (municipio !== null && localidad !== null) {
            helpHttp().post(`${BASE_API}Escuela/CargarEscuelas?idMunicipio=${municipio.IdMunicipio}&idLocalidad=${localidad}&idCicloEscolar=${ciclo.IdCicloEscolar}&parametrosExtra=${JSON.stringify(sup)}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                setEscuelas(res)
                setLstEscuelas([])
            })
        }
    }

    // function firstElemNotIn(curArray, prevArray) {
    //     return curArray.map(arr => {
    //         if (prevArray.find(a => a.Codigo === arr)) {
    //           arr.age++;
    //         }
    //         return arr;
    //       });
    // }

    const obtenerBase64 = () => {
        if (lstEscuelas.length > 0) {
            obtenerValesNominaMulti()
        }
    }

    const obtenerGrupos = (codigo) => {
        setSelectedGrupo(null)
        setErrors(validationsForm(codigo));
        if (Object.keys(validationsForm(codigo)).length === 0) {
            helpHttp().post(`${BASE_API}Reportes/SpdObtenerGradoGrupoXEscuela`, {
                body: {
                    Codigo: codigo,
                    Ciclo: ciclo.IdCicloEscolar
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.success) {
                    const formatGrupos = res.data.map(x => {
                        return {
                            ...x,
                            Descripcion: `${x.Grado} - ${x.Grupo}`
                        }
                    }).sort((a, b) => {
                        if (a.Descripcion < b.Descripcion) {
                            return -1;
                        }
                        if (a.Descripcion > b.Descripcion) {
                            return 1;
                        }

                        return 0;
                    });
                    setGetGrupos(formatGrupos)
                }
            })
        } else {
            setGetGrupos(null)
        }
    }

    const selectSup = (e) => {
        setLstSupervisiones(e)
        getEscuelas(e)
    }

    return (
        <>
            <Menu link='' />
            <Toast ref={toast} />
            <div className="grid card">
                <div className="col-12">
                    <TabView activeIndex={activeIndex} onTabChange={e => setActiveIndex(e.index)}>
                        <TabPanel header="Municipio">
                            <div>
                                <h3>Generación de vales por municipio</h3>
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-3">
                                        <label>Municipio:</label>
                                        <Dropdown id="municipio" name="municipio" filter value={municipio} options={municipios} optionLabel="Municipio" onChange={(e) => { setMunicipio(e.target.value); getLocalidades(e.target.value.IdMunicipio); }} />
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <label>Localidad:</label>
                                        <Dropdown id="localidad" name="localidad" filter value={localidad} options={localidades} optionLabel="Localidad" optionValue="IdLocalidad" onChange={(e) => { setLocalidad(e.target.value); getSupervisiones(municipio.IdMunicipio, e.target.value) }} />
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <label>Supervisión:</label>
                                        <MultiSelect id="supervisiones" filter disabled={supervisiones.length > 0 ? false : true} name="supervisiones" value={lstSupervisiones} options={supervisiones} optionLabel="descripcion" optionValue="id" onChange={(e) => { selectSup(e.target.value) }} />
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <label>CTs:</label>
                                        <MultiSelect id="escuelas" filter disabled={escuelas.length > 0 ? false : true} name="escuelas" value={lstEscuelas} options={escuelas} optionLabel="Codigo" optionValue="Codigo" onChange={(e) => { setLstEscuelas(e.target.value) }} />
                                    </div>
                                    {/* <div className="field col-12 md:col-2">
                                        <label htmlFor="opcion">Modalidad:</label>
                                        <Dropdown id="opcion" name="opcion" value={option} options={options} optionLabel="label" optionValue="value" onChange={(e) => setOption(e.target.value)} />
                                    </div> */}
                                    {option === 17 && <div className="field col-12 md:col-2">
                                        <label htmlFor="status">Estatus:</label>
                                        <Dropdown id="status" name="status" value={status} options={estatus} optionLabel="label" optionValue="value" onChange={(e) => setStatus(e.target.value)} />
                                    </div>}

                                </div>
                                <div className="p-dialog-footer">
                                    <div className=" border-top-1 surface-border pt-3 text-right">
                                        <Button name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-folder')} label="Exportar ZIP" onClick={() => obtenerBase64()} />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="CT">
                            <div>
                                <h3>Generación de vales por CT</h3>
                                <form onSubmit={obtenerValesNomina}>
                                    <div className="p-fluid formgrid grid">
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="ct">CT:</label>
                                            <InputText className={`${errors.ct && 'p-invalid'}`} id="ct" name="ct" value={ct} onBlur={(e) => obtenerGrupos(e.target.value.toUpperCase())} onChange={(e) => setCT(e.target.value.toUpperCase())} placeholder="Ingrese un Centro de Trabajo" />
                                            {errors.ct && <small className="p-error">{errors.ct}</small>}
                                        </div>
                                       {/*  <div className="field col-12 md:col-4">
                                            <label htmlFor="opcion">Modalidad:</label>
                                            <Dropdown id="opcion" name="opcion" value={option} options={options} optionLabel="label" optionValue="value" onChange={(e) => setOption(e.target.value)} />
                                        </div> */}
                                        {option === 17 &&
                                            <>
                                                <div className="field col-12 md:col-4 ">
                                                    <label htmlFor="grupos">Grupos:</label>
                                                    <MultiSelect id="grupos" name="grupos" value={selectedGrupos} onChange={(e) => setSelectedGrupo(e.value)} display="chip" options={getGrupos} optionLabel="Descripcion"
                                                        filter placeholder="Seleccionar grupos" />
                                                </div>
                                                <div className="field col-12 md:col-4 ">
                                                    <label htmlFor="status">Estatus:</label>
                                                    <Dropdown id="status" name="status" value={status} options={estatus} optionLabel="label" optionValue="value" onChange={(e) => setStatus(e.target.value)} />
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="p-dialog-footer">
                                        <div className=" border-top-1 surface-border pt-3 text-right">
                                            <Button type='submit' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-ticket')} label="Generar" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </TabPanel>
                        {[1].includes(parseInt(perfil)) && <TabPanel header="Consulta">
                            <div>
                                <h3>Generación de vales por consulta</h3>
                                <form onSubmit={obtenerValesNominaConsulta}>
                                    <div className="p-fluid formgrid grid">
                                        <div className="field col-12">
                                            <label htmlFor="cts">CT:</label>
                                            <InputText id="cts" name="cts" value={cts} onChange={(e) => setCTs(e.target.value.toUpperCase())} placeholder="Ingrese CTs separados por espacios" />
                                        </div>
                                        {/* <div className="field col-12 md:col-4">
                                            <label htmlFor="opcion">Modalidad:</label>
                                            <Dropdown id="opcion" name="opcion" value={option} options={options} optionLabel="label" optionValue="value" onChange={(e) => setOption(e.target.value)} />
                                        </div> */}
                                        {option === 17 && <div className="field col-12 md:col-4 ">
                                            <label htmlFor="status">Estatus:</label>
                                            <Dropdown id="status" name="status" value={status} options={estatus} optionLabel="label" optionValue="value" onChange={(e) => setStatus(e.target.value)} />
                                        </div>}
                                    </div>
                                    <div className="p-dialog-footer">
                                        <div className=" border-top-1 surface-border pt-3 text-right">
                                            <Button type='submit' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-ticket')} label="Generar" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </TabPanel>}
                    </TabView>
                </div>
            </div>
        </>
    )
}

export default ImprentaVales;